import {Button} from "flowbite-react";
import {BiLoaderAlt} from "react-icons/bi";

const ButtonLoading = (props) => {

    return (
        <>
        <Button
            {...props}
            disabled={props.isProcessing || props.disabled}
            isProcessing={false}
        >
            {props.isProcessing ? <BiLoaderAlt className={`animate-spin`} /> : props.children}
        </Button>
        </>
    );
};

export default ButtonLoading;
